import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAdminClients_idResend_verification_email = z.any()
export type TagsPostAdminClients_idResend_verification_email = z.infer<typeof tagsPostAdminClients_idResend_verification_email>

export const paramsPostAdminClients_idResend_verification_email = z.object({ "id": z.string() })
export type ParamsPostAdminClients_idResend_verification_email = z.infer<typeof paramsPostAdminClients_idResend_verification_email>

export const responsePostAdminClients_idResend_verification_email = z.any()
export type ResponsePostAdminClients_idResend_verification_email = z.infer<typeof responsePostAdminClients_idResend_verification_email>

interface IPostAdminClients_idResend_verification_email extends BaseMethodType {
  tags: TagsPostAdminClients_idResend_verification_email,
  params: ParamsPostAdminClients_idResend_verification_email,
  response: ResponsePostAdminClients_idResend_verification_email
}
export const URL = '/admin/clients/:id/resend-verification-email'
export const validation = {
  post: {
    tags: tagsPostAdminClients_idResend_verification_email,
    params: paramsPostAdminClients_idResend_verification_email,
    response: responsePostAdminClients_idResend_verification_email
  }
}
export interface AdminClients_idResend_verification_email extends BaseRouteType {
  post: IPostAdminClients_idResend_verification_email
}